import { type TipoComunicazioneDTO } from '@framework/api-client/api/inquiries-compile/schemas/tipoComunicazioneDTO.ts';
import { useFormSetValue } from '@framework/form/hooks/useFormSetValue.ts';
import {
  SelectInput,
  type SelectOption,
} from '@framework/form/inputs/SelectInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { t } from 'i18next';

interface ICommunicationTypeSelectInputProps {
  availableTypes: TipoComunicazioneDTO[];
}

interface CustomSelectOption extends SelectOption {
  data: TipoComunicazioneDTO;
}

/**
 * Componente per la selezione del tipo comunciazione
 * in alto nel drawer di configurazione di una comunicazione
 * (FO/BO)
 */
export function CommunicationTypeSelectInput(
  props: ICommunicationTypeSelectInputProps,
) {
  const { availableTypes } = props;

  const typeOptions: CustomSelectOption[] = availableTypes
    .filter(({ codice, id }) => !!codice && !!id)
    .map(type => ({
      label: type.codice!,
      value: type.id!,
      data: type,
    }));

  const setValue = useFormSetValue();

  return (
    <FormItem
      name="idTipoComunicazione"
      label={t('communications.type-label', 'Tipo Comunicazione')}
    >
      <SelectInput
        name="idTipoComunicazione"
        options={typeOptions}
        placeholder={t('communications.select', 'Selezione...')}
        onChange={(value, option, onChange) => {
          // Resetto i campi del form
          setValue('messaggio', null);
          setValue('oggetto', null);
          setValue('allegati', []);
          setValue('flMessaggioModificato', false);
          setValue('flOggettoModificato', false);
          setValue('noteAddizionali', '');
          setValue('destinatari', []);

          // Imposto il tipo comunicazione
          setValue('communicationType', (option as CustomSelectOption).data);
          onChange(value);
        }}
      />
    </FormItem>
  );
}
